// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avatar {
  padding: 3px;
  width: 70px;
  height: 70px;
}

.avatarMini {
  padding: 3px;
  width: 35px;
  height: 35px;
}

.list {
  padding: 0;
  border: 1px solid #e3e3e2;
  border-radius: 5px;
  height: 100%;
  max-height: inherit;
  overflow: hidden;
  display: flex;
  /* overflow-y: auto; */
  flex-direction: column;
}
.list .list-content {
  max-height: inherit;
  overflow-y: auto;
}
.list ion-item-divider {
  --background: var(--button-a-background);
  --color: var(--button-a-text);
}
.list ion-item-divider ion-icon {
  font-size: 13px;
  color: #fff;
}
.list ion-item-divider ion-label {
  margin: 0;
  padding: 0 5px;
}
.list ion-item {
  --min-height: 35px;
  border-bottom: 2px solid rgba(227, 227, 226, 0);
  font-size: 14px;
  color: #262626;
}
.list ion-item ion-label {
  margin: 0;
  white-space: pre-line !important;
}
.list ion-item ion-avatar {
  margin: 0;
  margin-inline-start: 0 !important;
  margin-inline-end: 0 !important;
}
.list ion-item:nth-child(odd) {
  --background: #fafafa;
}
.list ion-item:active, .list ion-item:hover {
  cursor: pointer;
  font-weight: bold;
  filter: brightness(95%);
}

.list-content ion-item ion-label {
  margin: 0 10px;
  white-space: pre-line !important;
}
.list-content ion-item ion-avatar {
  margin: 0;
  margin-inline-start: 0 !important;
  margin-inline-end: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/section/components/menu-nav/menu-nav.component.scss"],"names":[],"mappings":"AAAA;EAEE,YAAA;EACA,WAAA;EACA,YAAA;AAAF;;AAEA;EAEE,YAAA;EACA,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AAAF;AAEE;EACE,mBAAA;EACA,gBAAA;AAAJ;AAIE;EACE,wCAAA;EACA,6BAAA;AAFJ;AAII;EACE,eAAA;EACA,WAAA;AAFN;AAKI;EACE,SAAA;EACA,cAAA;AAHN;AAOE;EACE,kBAAA;EACA,+CAAA;EACA,eAAA;EACA,cAAA;AALJ;AAOI;EACE,SAAA;EACA,gCAAA;AALN;AAOI;EACE,SAAA;EACA,iCAAA;EACA,+BAAA;AALN;AASE;EACE,qBAAA;AAPJ;AAUE;EACE,eAAA;EACA,iBAAA;EAGA,uBAAA;AAVJ;;AAiBI;EACE,cAAA;EACA,gCAAA;AAdN;AAgBI;EACE,SAAA;EACA,iCAAA;EACA,+BAAA;AAdN","sourcesContent":[".avatar {\n  //margin: 0 auto;\n  padding: 3px;\n  width: 70px;\n  height: 70px;\n}\n.avatarMini {\n  //margin: 0 auto;\n  padding: 3px;\n  width: 35px;\n  height: 35px;\n}\n\n.list {\n  padding: 0;\n  border: 1px solid #e3e3e2;\n  border-radius: 5px;\n  height: 100%;\n  max-height: inherit;\n  overflow: hidden;\n  display: flex;\n  /* overflow-y: auto; */\n  flex-direction: column;\n\n  .list-content {\n    max-height: inherit;\n    overflow-y: auto;\n  }\n\n\n  ion-item-divider {\n    --background: var(--button-a-background);\n    --color: var(--button-a-text);\n\n    ion-icon {\n      font-size: 13px;\n      color: #fff;\n    }\n\n    ion-label {\n      margin: 0;\n      padding: 0 5px;\n    }\n  }\n\n  ion-item {\n    --min-height: 35px;\n    border-bottom: 2px solid #e3e3e200;\n    font-size: 14px;\n    color: #262626;\n\n    ion-label {\n      margin: 0;\n      white-space: pre-line !important;\n    }\n    ion-avatar{\n      margin: 0;\n      margin-inline-start: 0 !important;\n      margin-inline-end: 0 !important;\n    }\n  }\n\n  ion-item:nth-child(odd) {\n    --background: #fafafa;\n  }\n\n  ion-item:active, ion-item:hover {\n    cursor: pointer;\n    font-weight: bold;\n    //border-top: 1px solid;\n    //border-color: #c1c1c1;\n    filter: brightness(95%);\n  }\n}\n\n.list-content{\n\n  ion-item {\n    ion-label {\n      margin: 0 10px;\n      white-space: pre-line !important;\n    }\n    ion-avatar{\n      margin: 0;\n      margin-inline-start: 0 !important;\n      margin-inline-end: 0 !important;\n    }\n  }\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
